import React, {useEffect, useState} from 'react';
import {Button, Grid, Typography} from "@mui/material";
import {Link, useNavigate} from "react-router-dom";
import ApiService from "../services/ApiService";
import AgGrid from "./AgGrid";
import {enabledFormatter} from "../configuration/agGridFormatterFunctions";

const data = {
    columnDefs: [
        {
            headerName: "Nome funzione", field: "name", minWidth: 200, sortable: true,
            filter: 'agTextColumnFilter',
            filterParams: {suppressAndOrCondition: true}
        },
        {
            headerName: "Budget attuale (CHF)",
            field: "availableAmountFormatted",
            minWidth: 200,
            sortable: true,
            filter: 'agTextColumnFilter',
            filterParams: {suppressAndOrCondition: true}
        },
        {
            headerName: "Budget iniziale (CHF)",
            field: "amountFormatted",
            minWidth: 200,
            sortable: true,
            filter: 'agTextColumnFilter',
            filterParams: {suppressAndOrCondition: true}
        },
        {
            headerName: "Budget aggiuntivo (CHF)",
            field: "arbitraryAmountFormatted",
            minWidth: 200,
            sortable: true,
            filter: 'agTextColumnFilter',
            filterParams: {suppressAndOrCondition: true}
        },
        {
            headerName: "N. studenti SI", field: "primarySchoolStudents", minWidth: 130, sortable: true,
            filter: 'agNumberColumnFilter',
            filterParams: {suppressAndOrCondition: true}
        },
        {
            headerName: "N. studenti SE 1° ciclo",
            field: "elementarySchoolFirstCycleStudents",
            minWidth: 130,
            sortable: true,
            filter: 'agNumberColumnFilter',
            filterParams: {suppressAndOrCondition: true}
        },
        {
            headerName: "N. studenti SE 2° ciclo",
            field: "elementarySchoolSecondCycleStudents",
            minWidth: 130,
            sortable: true,
            filter: 'agNumberColumnFilter',
            filterParams: {suppressAndOrCondition: true}
        },
        {
            headerName: "Archiviato",
            field: "enabled",
            cellRenderer: enabledFormatter,
            minWidth: 100,
            sortable: true,
            filter: 'agTextColumnFilter',
            filterParams: {suppressAndOrCondition: true}
        },
        {
            headerName: "", suppressMenu: true, pinned: 'right', lockPinned: true,  cellRenderer: function (params) {
                return (
                    <Grid container spacing={1} justifyContent={'flex-end'}>
                        <Grid item>
                            <Link className={'muiBtn muiBtnPrimary'} to={'/function-details/' + params.data.id}>
                                Visualizza
                            </Link>
                        </Grid>
                        {params.data.enabled ?
                            <Grid item>
                                <Link className={'muiBtn muiBtnSecondary'} to={'/edit-function/' + params.data.id}>
                                    Modifica
                                </Link>
                            </Grid>
                            :
                            ''
                        }
                    </Grid>
                )
            },
            minWidth: 220,
            suppressSizeToFit: true,
        },
    ],
    defaultColDef: {
        resizable: true,
        flex: 1,
    },
    rowData: []
}

export default function Functions() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        ApiService.getBudgets().then(response => response.json()).then(response => {
            setLoading(false);
            const budgets = response;
            if (budgets.length > 0) {
                data.rowData = budgets;
            }
        });
    }, [])

    return (<>
        <Grid container sx={{marginTop: 2}} justifyContent={'space-between'}>
            <Grid item xs='auto'>
                <Typography variant="h5" component="h2" sx={{fontWeight: '500'}}>Funzioni</Typography>
            </Grid>
            <Grid item xs='auto'>
                <Button variant="contained" color="primary"
                        fullWidth
                        onClick={() => {
                            navigate("/edit-function")
                        }}>
                    Crea funzione
                </Button>
            </Grid>
        </Grid>
        {loading ?
            ''
            :
            <Grid container sx={{my: 3}}>
                <Grid item xs={12}>
                    <AgGrid children={data}/>
                </Grid>
            </Grid>
        }
    </>);
}